import { Loader } from '@components/loader';
import { MerchantLinksList } from '@pages/merchantLinks';
import { useMerchantLinkList } from '@services/staff/merchant/links/list';
import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { outletNavScroll } from '@utils/apiHelpers';
import { useEffect } from 'react';

function MerchantLinks() {
  const navigate = useNavigate();
  const { merchantId, localId } = useParams({
    from: '/u/$localId/_staff/staff/merchants/$merchantId/links',
  });
  const { data, isPending } = useMerchantLinkList({ merchantId });

  useEffect(() => {
    outletNavScroll();
  }, []);

  if (isPending) return <Loader />;

  return (
    <MerchantLinksList
      data={data}
      onRowSelect={(id) => {
        navigate({
          to: `/u/$localId/staff/merchants/$merchantId/links/$id`,
          params: { merchantId, id, localId },
        }).catch((err) => console.error(err));
      }}
      newRedirect={() => {
        navigate({
          to: `/u/$localId/staff/merchants/$merchantId/links/new`,
          params: { merchantId, localId },
        }).catch((err) => console.error(err));
      }}
    />
  );
}

export const Route = createFileRoute('/u/$localId/_staff/staff/merchants/$merchantId/links')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['merchant_links_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: MerchantLinks,
});
